import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { makeUsers } from "@client.pages/Settings/reducer";
import Icon from "@client.components/Icon";
import CalendarEventAcceptanceTypes from "@client.enums/calendarEventAcceptanceTypes";
import { useTranslation } from "react-i18next";
import { meetingType } from "./types";
import Dropdown from "@client.components/Dropdown";
import { formatDate } from "@client.utils/dateUtils";
import { DateFormat } from "@client.enums/dateTypes";
import "./MeetingResponseContent.scss";

const MeetingResponseContent = ({ rowData, meetings }) => {
  const users = useSelector(makeUsers);
  const [meeting, setMeeting] = useState(rowData);

  const { t } = useTranslation();
  const {
    eventResponses: responses,
    attendeesQty,
    acceptancePercentage,
  } = meeting;
  return (
    <div className="meeting-response-content">
      {meetings.length > 1 && (
        <div className="meeting-instance">
          <div className="meeting-instance-caption">
            <span>
              {t(
                "components.Reports.MeetingsDataTable.MeetingResponseContent.selectMeetingInstance"
              )}
              :
            </span>
            <span className="meeting-instance-avg-info">
              {t(
                "components.Reports.MeetingsDataTable.MeetingResponseContent.avgInfo",
                {
                  qty: meetings.length,
                  avgPercentage: (
                    meetings.reduce((sum, { acceptancePercentage }) => {
                      return sum + acceptancePercentage;
                    }, 0) / meetings.length
                  ).toFixed(2),
                }
              )}
            </span>
          </div>
          <Dropdown
            items={meetings.map((m) => ({
              id: m.id,
              name: `${m.name} (${formatDate(m.startDate, DateFormat)})`,
            }))}
            valueKey="id"
            labelKey="name"
            defaultValue={rowData.id}
            onSelect={(val) => {
              setMeeting(meetings.find((m) => m.id === val));
            }}
          />
        </div>
      )}
      <div className="full-event-info">
        <Icon name="global" isSvg={true} />
        {t(
          "components.Reports.MeetingsDataTable.MeetingResponseContent.fullInfo",
          {
            total: attendeesQty,
            accepted: responses.filter(
              (r) => r.status === CalendarEventAcceptanceTypes.Accepted
            ).length,
            declined: responses.filter(
              (r) => r.status === CalendarEventAcceptanceTypes.Declined
            ).length,
            rate: acceptancePercentage,
          }
        )}
      </div>
      <ul>
        {responses.map((r) => {
          const user = users.data.find((u) => u.email === r.email);
          let imgName;
          switch (r.status) {
            case CalendarEventAcceptanceTypes.Accepted:
              imgName = "accepted";
              break;
            case CalendarEventAcceptanceTypes.Declined:
              imgName = "declined";
              break;
            default:
              imgName = "noResponse";
          }
          const attendee = user
            ? `${user.firstName} ${user.lastName} (${user.email})`
            : r.email;
          return (
            <li key={r.email + r.status}>
              <Icon name={imgName} isSvg={true} />
              <span className="attendee" title={attendee}>
                {attendee}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

MeetingResponseContent.propTypes = {
  rowData: meetingType,
  meetings: PropTypes.arrayOf(meetingType),
};

export default MeetingResponseContent;
